window.FeatureTracking = new function () {
  this.trackEditorEvent = function(type) {
    gtag('event', 'editor_ux', {
      'category': 'UX',
      'type': type
    });
  }

  this.upgrade = function(value)
  {
    gtag('event', 'pro_upgrade', {
      'category': 'UX',
      'type': value
    });
  }

  this.update = function () {
      if (!this.smRegistered) {
          window.sm.ui.addListener(scribblemaps.UIEvent.TOOL_SELECT, function (evt) {
            gtag('event', 'tracking_tools', {
              'category': 'UX',
              'type': evt.data
            });
          });


          window.sm.ui.addListener(scribblemaps.UIEvent.SUBMENU_SELECT, function(evt) {
            if (evt.data.id) {

              gtag('event', 'tracking_submenu', {
                'category': 'UX',
                'type': evt.data.id
              });
              }
          });

          window.sm.ui.addListener(scribblemaps.UIEvent.PANEL_CLOSE, function (evt) {
            gtag('event', 'tracking_panels', {
              'category': 'UX',
              'type': evt.data
            });
          });

          window.sm.ui.addListener(scribblemaps.UIEvent.GIS_RUN, function (evt) {
              var type = evt.data.title.split(" ").join("_").toLowerCase();
              gtag('event', 'tracking_gis', {
                'category': 'UX',
                'type': type
              });
          });


          window.sm.ui.addListener(scribblemaps.UIEvent.LIST_MAPPED, function (evt) {
            gtag('event', 'tracking_import', {
              'category': 'UX',
              'type': 'List'
            });
          });

          window.sm.ui.addListener(scribblemaps.UIEvent.MENU_SELECT, function (evt) {
              var type = evt.data;
              gtag('event', 'tracking_menu', {
                'category': 'UX',
                'type': type
              });
          });

          this.smRegistered = true;
      }
  }
}();
